import Shape from './Shape';
import { Point, Path } from 'paper';

export class ImportedCircle extends Shape {
    constructor(item) {
        super('importedcircle', ['select', 'delete']);

        this.centerX = item.position.x;
        this.centerY = item.position.y;
        this.radius = item.radius * item.scaling.x;
        this.family = 'cut';

        this.pathId = item.id;
    }

    get center() {
        return new Point({ x: this.centerX, y: this.centerY });
    }

    set center(center) {
        this.centerX = center.x;
        this.centerY = center.y;
    }

    async updatePath() {
        let path = new Path.Circle({
            center: this.center,
            radius: this.radius
        });

        path.rotation = this.rotation;

        this.linkTo(path);
        return path;
    }
}
